import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../../context/AuthContext";
import MDBox from "components/MDBox";
import CircularProgress from "@mui/material/CircularProgress";

const PrivateRoute = ({ children, permission }) => {
  const { isAuthenticated, loading, hasPermission } = useAuth();

  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress color="info" />
      </MDBox>
    );
  }

  if (!isAuthenticated) return <Navigate to="/authentication/sign-in" replace />;

  // If a permission key is required and the user doesn't have it, send to dashboard
  if (permission && !hasPermission(permission)) return <Navigate to="/dashboard" replace />;

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string,
};

PrivateRoute.defaultProps = {
  permission: null,
};

export default PrivateRoute;
